import CountUp from "react-countup"
import { Flame, PhoneCall, TrendingUp, Moon, AlertTriangle } from "lucide-react"
import { cn } from "../../utils/classnames"
import { LeadScoreCategory, LeadScoreStats } from "../../../types"
import { CATEGORY_CONFIG, CATEGORIES } from "./category-helpers"

interface Props {
  stats: LeadScoreStats | undefined
  activeCategory: LeadScoreCategory | null
  onCategoryClick: (category: LeadScoreCategory | null) => void
}

const CATEGORY_ICONS: Record<LeadScoreCategory, React.ElementType> = {
  hot_lead: Flame,
  needs_contact: PhoneCall,
  engaged: TrendingUp,
  dormant: Moon,
  at_risk: AlertTriangle
}

const ScoreSummaryCards = ({
  stats,
  activeCategory,
  onCategoryClick
}: Props) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
      {CATEGORIES.map((category, i) => {
        const config = CATEGORY_CONFIG[category]
        const Icon = CATEGORY_ICONS[category]
        const count = stats?.[category] ?? 0
        const isActive = activeCategory === category

        return (
          <button
            key={category}
            onClick={() => onCategoryClick(isActive ? null : category)}
            className={cn(
              "bg-white rounded-lg border-t-2 border border-neutral-200 p-4 text-left transition-all",
              "hover:shadow-md cursor-pointer",
              config.cardAccentClass,
              isActive && "ring-2 ring-primary-400 shadow-md"
            )}
          >
            <div className="flex items-center gap-2 mb-2">
              <Icon size={16} className="text-neutral-500" />
              <span className="text-xs font-medium text-neutral-500 uppercase tracking-wide">
                {config.labelPlural}
              </span>
            </div>
            <div className="text-2xl font-bold text-neutral-800">
              <CountUp end={count} duration={0.8} delay={i * 0.15} />
            </div>
            {count > 0 && stats?.avg_score != null && !activeCategory && (
              <div className="text-xs text-neutral-400 mt-1">
                {count} of {stats.total}
              </div>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default ScoreSummaryCards
